import React from 'react';
import Icon from '../../../../../CommonComponents/Icon';
import {
  Button,
  ButtonImage,
  ButtonLegend,
  ButtonTextWrapper,
  ButtonTitle,
} from './AddAccountButtonStyles';

interface Image {
  src: string;
  alt: string;
}

interface Props {
  disabled?: boolean;
  icon?: string;
  image?: Image;
  isLoading?: boolean;
  legend?: string | null;
  onClick?: (event) => void;
}

export const AddAccountButton: React.FC<Props> = ({
  children,
  disabled,
  icon,
  image,
  isLoading,
  legend,
  onClick,
  ...props
}) => (
  <Button {...props} isLoading={isLoading} disabled={disabled} onClick={onClick}>
    {image?.src && <ButtonImage src={image?.src} alt={image.alt} />}

    {icon && <Icon className={icon} css="width: 48px; text-align: center" />}

    <ButtonTextWrapper>
      <ButtonTitle>{children}</ButtonTitle>
      {legend && <ButtonLegend>{legend}</ButtonLegend>}
    </ButtonTextWrapper>
  </Button>
);
